import { render } from "./ActiveScreen.vue?vue&type=template&id=47eb9926"
import script from "./ActiveScreen.vue?vue&type=script&lang=js"
export * from "./ActiveScreen.vue?vue&type=script&lang=js"

import "./ActiveScreen.vue?vue&type=style&index=0&id=47eb9926&lang=css"

import exportComponent from "/Users/peterdevos/Sites/clawmachine_yardi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__